import React, { useEffect, useState, useMemo } from 'react';
//import { Box, Typography, Link, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions  } from '@mui/material';
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import Pagination from "@mui/material/Pagination";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function Page2SubPageB2() {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);

  const history = useHistory(); 
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [success, setSuccess] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
  const [comment, setComment] = useState("");
  const [activePostId, setActivePostId] = useState(null);

  const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
  const [pendingUndoBill, setPendingUndoBill] = useState(null);

  const [openVotersDialog, setOpenVotersDialog] = useState(false);
  const [activeVoters, setActiveVoters] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [sortMode, setSortMode] = useState("recent"); // default

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState("");

  const [loggedInUser, setLoggedInUser] = useState(null);
  useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/govPosts', {
        title,
        content,
        topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
      });
      setOpen(false);
      setTitle('');
      setContent('');
      alert('Post created!');
    } catch (err) {
      console.error('Failed to create post', err);
    }
  };

  /*
  useEffect(() => {
    axios.get('/api/house-floor-bills')
      .then(res => setBills(res.data))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);
  */
/*
  useEffect(() => {
    axios.get('/api/house-floor-bills')
        .then(res => {
        const sorted = res.data
            .map(bill => ({
            ...bill,
            upvoteCount: bill.upvoters?.length || 0, // safe fallback
            }))
            .sort((a, b) => b.upvoteCount - a.upvoteCount); // sort descending

        setBills(sorted);
        })
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }, []);
*/
/*
  useEffect(() => {
    axios.get('/api/house-floor-bills')
        .then(res => {
        const sorted = res.data
            .map(bill => ({
            ...bill,
            upvoteCount: bill.power_votes.reduce((sum, tuple) => sum + (tuple.pVotes || 0), 0),
            //passCount: bill.passPowerVotes.reduce((sum, tuple) => sum + (tuple.pVotes || 0), 0),
            //noPassCount: bill.noPassPowerVotes.reduce((sum, tuple) => sum + (tuple.pVotes || 0), 0),
            }))
            .sort((a, b) => b.upvoteCount - a.upvoteCount); // sort descending

        setBills(sorted);
        })
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }, []);*/
    /*useEffect(() => {
        axios.get('/api/house-floor-bills')
            .then(res => setBills(res.data))

            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, []);
    */
   const fetchBills = async (pageNumber = 1, sort = sortMode) => {
    try {
        setLoading(true);
        const res = await axios.get("/api/house-floor-bills", {
            params: { page: pageNumber, limit: 20, sort },
        });
            setBills(res.data.bills);
            setTotalPages(res.data.totalPages);
            setPage(res.data.currentPage);
            setError("");
        } catch (err) {
        console.error(err);
        setError("Failed to fetch bills");
        } finally {
        setLoading(false);
        setInitialLoading(false);
        }
    };

    // Reset to page 1 whenever state OR sortMode changes
    useEffect(() => {
        setInitialLoading(true);
        setPage(1);
        fetchBills(1, sortMode);
    }, [sortMode]);

    // Regular page changes (pagination clicks)
    useEffect(() => {
        fetchBills(page, sortMode);
    }, [page]);

    const PAGE_JUMP = 10;

   const jumpBackward = () => {
    setPage(prev => Math.max(prev - PAGE_JUMP, 1));
   };

   const jumpForward = () => {
    setPage(prev => Math.min(prev + PAGE_JUMP, totalPages));
   };

  const handleAddComment = async (billId, text) => {
    if (!text) return;
    try {
        await axios.post(`/bill/${billId}/comment`, { text });
        alert("Comment added");
    } catch (err) {
        console.error("Comment error", err);
    }
    };
    
    /*
    const toggleVote = async (billId) => {
        try {
        const res = await axios.post(`/bill/${billId}/upvote`);
        setBills(prevBills =>
            prevBills.map(bill =>
            bill._id === billId
                ? { 
                    ...bill, 
                    upvotersCount: res.data.upvotes,
                    voted: res.data.voted
                }
                : bill
            )
        );
        } catch (err) {
        console.error('Error toggling vote:', err);
        }
    };
    */

    /*
    const toggleVote = async (billId) => {
        try {
            const res = await axios.post(`/bill/${billId}/upvote`);
            const { upvotes, voted } = res.data;

            setBills(prevBills =>
            prevBills.map(bill =>
                bill._id === billId
                ? {
                    ...bill,
                    upvoteCount: upvotes, // use the correct key you display
                    voted: voted,
                    }
                : bill
            )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };
    */
   const toggleVote = async (billId) => {
    try {
        const res = await axios.post(`/bill/${billId}/upvote`);
        const { upvotes, voted } = res.data;

        setBills(prevBills => {
            const updated = prevBills.map(bill =>
                bill._id === billId
                ? { ...bill, upvoteCount: upvotes, voted }
                : bill
            );

        return updated;

        // Sort again after update
        //return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
        });
    } catch (err) {
        console.error('Error toggling vote:', err);
    }
    };

    const joinVideoCall = async (billId) => {
        try {
            const res = await axios.post(`/bill/${billId}/video-room`);
            const url = res.data.url;
            window.open(url, "_blank");
        } catch (err) {
            console.error("Error joining video room:", err);
            alert("Could not join video room");
        }
    };

  if (loading) return <Typography>Loading bills...</Typography>;
  if (!bills.length) return <Typography>No bills found.</Typography>;
/*
    const togglePass = async (billId) => {
        try {
            const res = await axios.post(`/bill/${billId}/pass`);
            const { upvotes, billVoted } = res.data;
 
            setBills(prev =>
                prev.map(bill => bill._id === billId ? { ...bill, passCount: upvotes, billVoted } : bill)
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

    const toggleNoPass = async (billId) => {
        try {
            const res = await axios.post(`/bill/${billId}/noPass`);
            const { upvotes, billVoted } = res.data;
  
            setBills(prev =>
                prev.map(bill => bill._id === billId ? { ...bill, noPassCount: upvotes, billVoted } : bill)
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
   };

    const handleOpenDialog = (billId) => {
        setActivePostId(billId);
        setOpenDialog(true);
    };

    const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            await axios.post(`/bill/${activePostId}/comment`, { text: comment });

            if (voteType === "Pass") {
                await togglePass(activePostId);
            } else {
                await toggleNoPass(activePostId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };*/
    const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };

  const toggleNoPass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/bill/${billId}/noPass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setBills(prev =>
                prev.map(bill =>
                    bill._id === billId
                    ? {
                        ...bill,

                        // update counts
                        noPassCount: upvotes,
                        //billVoted,

                        votedBill: true,
                        votedSide: "no pass",

                        // update voter list 
                        /*billVoters: [
                            ...(bill.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record no pass vote
                        noPassPowerVotes: [
                            ...(bill.noPassPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure pass votes does NOT contain user
                        passPowerVotes: (bill.passPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : bill
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const togglePass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/bill/${billId}/pass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setBills(prev =>
                prev.map(bill =>
                    bill._id === billId
                    ? {
                        ...bill,

                        // update counts
                        passCount: upvotes,
                        //billVoted,

                        votedBill: true,
                        votedSide: "pass",

                        // update voter list
                        /*billVoters: [
                            ...(bill.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record pass vote
                        passPowerVotes: [
                            ...(bill.passPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from no pass votes if present
                        noPassPowerVotes: (bill.noPassPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : bill
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const handleOpenDialog = (billId) => {
        setActivePostId(billId);
        setOpenDialog(true);
    };

  const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            const commentRes = await axios.post(
                `/bill/${activePostId}/comment`,
                { text: comment }
            );

            const commentId = commentRes.data._id; 

            if (voteType === "NP") {
                await toggleNoPass(activePostId, commentId);
            } else {
                await togglePass(activePostId, commentId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (billId, bill) => {
	    const res = await axios.post(`/bill/${billId}/undoVote`);

        const { upvotes, billVoted } = res.data;

       if (
            bill.noPassPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setBills(prev =>
                    prev.map(c =>
                    c._id === billId
                        ? {
                            ...c,

                            // keep working count logic
                            noPassCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (c.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            noPassPowerVotes: (c.noPassPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            } else if (
                bill.passPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setBills(prev =>
                    prev.map(c =>
                    c._id === billId
                        ? {
                            ...c,

                            // keep working count logic
                            passCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (c.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            passPowerVotes: (c.passPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            }
    };*/
    const handleUndoVote = async (billId, bill) => {
        try {
            const res = await axios.post(`/bill/${billId}/undoVote`);
            const { upvotes } = res.data;

            setBills(prev =>
                prev.map(c => {
                    if (c._id !== billId) return c;

                    const updated = { ...c };

                    if (c.votedSide === "no pass") {
                        updated.noPassCount = upvotes;
                    } else if (c.votedSide === "pass") {
                        updated.passCount = upvotes;
                    }

                    updated.votedBill = false;
                    updated.votedSide = null;

                    return updated;
                })
            );
        } catch (err) {
            console.error(err);
        }
    };

    /*const openNoPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");
        setActiveVoters(bill.noPassPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");
        setActiveVoters(bill.passPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openNoPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");

        try {
            const res = await axios.get(`/bill/${bill._id}/voters?side=no pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");

        try {
            const res = await axios.get(`/bill/${bill._id}/voters?side=pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

    /*
    const sortedBills = useMemo(() => {
        if (!bills) return [];

        const copy = [...bills];

        if (sortMode === "popular") {
            return copy.sort((a, b) => b.upvoteCount - a.upvoteCount);
        }

        // recent (latest action)
        return copy.sort(
            (a, b) =>
                new Date(b.latestAction?.date || 0) -
                new Date(a.latestAction?.date || 0)
        );
    }, [bills, sortMode]);*/
    const sortedBills = [...bills].sort((a, b) => {
        if (sortMode === "popular") {
            return b.upvoteCount - a.upvoteCount;
        }

        return (
            new Date(b.latestAction?.date || 0) -
            new Date(a.latestAction?.date || 0)
        );
    });

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular Opinion", path: "/Government/popular" },
      { label: "Following", path: "/Government/following" },
      { label: "Supreme Court", path: "/Government/SupremeCourt" },
      { label: "Congressional Bills", path: "/Government/CongressionalBills" },
      { label: "State Legislature Bills", path: "/Government/StateBills" },
      { label: "Elections", path: "/Government/Elections/GubernatorialElections" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
        </Box>*/}
        {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
        <Box
                sx={{
                    maxWidth: 900,        // match your case card width
                    mx: "auto",           // center container
                }}
            >
            <Box
                display="flex"
                justifyContent="flex-start"
                gap={1}
                mb={2}
                //sx={{ ml: 2 }}
            >
                <Button
                    size="small"
                    variant={sortMode === "popular" ? "contained" : "outlined"}
                    onClick={() => setSortMode("popular")}
                >
                    High Visibility Bills
                </Button>
                <Button
                    size="small"
                    variant={sortMode === "recent" ? "contained" : "outlined"}
                    onClick={() => setSortMode("recent")}
                >
                    Latest Action Bills
                </Button>
            </Box>
      {/*<Typography variant="h4" gutterBottom>House Floor Bills</Typography>*/}
      {bills.map((bill, i) => {
        const billPassCount = bill.passCount || 0;
        const billNoPassCount = bill.noPassCount || 0;
        let votePercentage = 0;
	 
        if (billPassCount > billNoPassCount) {
            votePercentage = billPassCount/(billPassCount+billNoPassCount)
        } else if (billNoPassCount > billPassCount) {
            votePercentage = billNoPassCount/(billPassCount+billNoPassCount)
        }

        let offset = 0;
        if (billPassCount > billNoPassCount) {
            offset = votePercentage * 50; // move right
        } else if (billNoPassCount > billPassCount) {
            offset = -votePercentage * 50; // move left
        }

        let tickColor = "blue"; // default at center
        if (offset > 0) {
            tickColor = "#00c853"; // right side
        } else if (offset < 0) {
            tickColor = "red"; // left side
        }

        return (
        <Box 
            key={i} // unique key for each list item
            onClick={() => history.push(`/bill/${bill._id}/comments`)}
            p={2} // padding inside box
            my={2} // vertical margin between posts
            border="1px solid #ccc" // light grey border
            borderRadius="8px" // rounded corners
            sx={{ 
                position: "relative", 
                maxWidth: 900, // limit width 
                mx: "auto", // center horizontally
                my: 2, // vertical spacing between each post
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#f9f9f9"
                }
            }}
        >
        {/*<Button
            onClick={(e) => {
                e.stopPropagation();  
                joinVideoCall(bill._id)}
            }
            variant="outlined"
            size="small"
            sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 1
            }}
        >
            Join Video Call
        </Button>*/}

        <Typography 
                fontWeight="bold"
                sx={{
                    wordBreak: "break-word",
                    pr: "140px",
                    mb: 1
                }}
            >
                {bill.billNum}: {bill.title}
        </Typography>

        {/*<Typography 
            variant="body2"
        >
            <Box component="span" fontWeight="bold">
                Summary:
            </Box>{' '}
            {bill.summary}
        </Typography>*/}
        <Typography variant="body2" component="div">
            <Box component="span" fontWeight="bold">
                Summary:
            </Box>

            <Box
                component="div"
                sx={{ mt: 0.5 }}
                dangerouslySetInnerHTML={{ __html: bill.summary }}
            />
        </Typography>

        <Typography variant="body2">
            <Box component="span" fontWeight="bold">
                Latest Action:
            </Box>{' '}
            {bill.latestAction
                ? `${bill.latestAction.date} — ${bill.latestAction.text}`
                : 'No recent action'}
        </Typography>

        {/*<Typography 
            variant="body2"
        >
            Bill Text: {bill.billText}
        </Typography>*/}
        {bill.billText ? (
            <Link 
                href={bill.billText} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ display: "block" }}
            >
                Bill Web Text
            </Link>
            ) : (
            <Typography 
                variant="caption"
                sx={{ display: "block" }}
            >
                Bill text not available
            </Typography>
        )}

        {/*<Link 
            href={bill.pdf} 
            target="_blank" 
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
        >
            View PDF
          </Link>*/}
          {bill.pdf ? (
            <Link
                href={bill.pdf}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                sx={{ display: "block" }}
            >
                Bill PDF
            </Link>
            ) : (
            <Typography 
                variant="caption" 
                color="text.secondary"
                sx={{ display: "block" }}
            >
                PDF not available
            </Typography>
        )}


        {/*<Box 
            display="flex" 
            justifyContent="center" 
            sx={{ 
                mb: 2, 
                //my: 1 
            }}
        >
            <Button 
                variant="outlined" 
                size="small"
                onClick={(e) => {
                    e.stopPropagation();  
                    handleOpenDialog(bill._id)}
                }
                sx={{ ml: 2.3 }} 
            >
                Vote
            </Button>
        </Box>*/}
        {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    bill.billVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    bill.noPassPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted No Pass
                    </Button>
                    ) : loggedInUser && bill.passPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted Pass
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPendingUndoCaseId(bill._id);
                            setPendingUndoBill(bill);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(bill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && bill.votedBill ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ ml: 2.3 }}
                        >
                            {bill.votedSide === "no pass"
                            ? "Voted No Pass"
                            : "Voted Pass"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", ml: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(bill._id);
                                setPendingUndoBill(bill);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(bill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>

        {/* Vote bar with tick */}
        <Box 
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            sx={{ mb: 2 }}
            >
            {/* Downvote button */}
            {/*<Button 
                variant="outlined" 
                size="small"
                onClick={() => toggleNoPass(bill._id)}
            >
                No Pass
            </Button>*/}
            {/*<Typography variant="body2">{bill.noPassCount} No Pass Votes</Typography>*/}
            <Typography variant="body2">No Pass Votes</Typography>

            {/* Bar with tick in middle */}
            <Box 
                sx={{ 
                    position: "relative", 
                    height: "2px", 
                    backgroundColor: "#ccc", 
                    width: "300px",
                    mx: 2 
                }}>
                    {/* Tick in the center */}
                    <Box sx={{ 
                        position: "absolute", 
                        top: "-6px", 
                        left: "50%", 
                        transform: "translateX(-50%)", 
                        width: "2px", 
                        height: "14px", 
                        backgroundColor: "black" 
                    }} />
                
                {/* Dynamic tick + percentage */}
                <Box 
                    sx={{ 
                        position: "absolute", 
                        top: "-6px", 
                        left: `calc(50% + ${offset}%)`, 
                        transform: "translateX(-50%)", 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center"
                    }}
                    >
                    {/* Tick */}
                    <Box sx={{ 
                        width: "2px", 
                        height: "14px", 
                        backgroundColor: tickColor 
                    }} />

                    {/* Percentage */}
                    <Typography 
                        variant="caption" 
                        sx={{ mt: "2px", fontSize: "0.7rem" }}
                    >
                        {(votePercentage * 100).toFixed(0)}%
                    </Typography>
                    </Box>
                </Box>

                {/* Upvote button */}
                {/*<Button 
                    variant="outlined" 
                    size="small"
                    onClick={() => togglePass(bill._id)}  
                >
                    Pass
                </Button>*/}
                {/*<Typography variant="body2">{bill.passCount} Pass Votes</Typography>*/}
                <Typography variant="body2">Pass Votes</Typography>
        </Box>

        {/*<Box 
            display="flex" 
            justifyContent="center" 
        >
            <Typography variant="body2">{bill.noPassCount} {bill.passCount} </Typography>
        </Box>*/}
        {/*<Box display="flex" justifyContent="space-between" sx={{ width: "300px" }}>
            <Box display="flex" flexDirection="column" alignItems="center" sx={{ ml: 34 }}> 
                <Typography variant="body2">{bill.noPassCount}</Typography>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="center" sx={{ ml: 53 }}> 
            <Typography variant="body2">{bill.passCount}</Typography>
            </Box>
        </Box>*/}

        {/*<Box key={i} mb={2} p={2} border="1px solid #ccc" borderRadius="6px">*/}
          {/* Title and Video Call Button Row */}
            {/*<Box display="flex" justifyContent="space-between" alignItems="center">*/}
            {/*<Typography 
                fontWeight="bold"
                sx={{
                    wordBreak: "break-word",
                    pr: "140px" // reserve space for button (adjust if needed)
                }}
            >
                {bill.title}
            </Typography>*/}
            {/*<Button
                variant="contained"
                size="small"
                onClick={() => joinVideoCall(bill._id)}
            >
                Join Video Call
            </Button>*/}
           {/* </Box>*/}

          {/* Upvote button & count */}
          {/*}
          <Typography variant="body2" mt={1}>
            {bill.upvoteCount ?? 0} upvotes
          </Typography>
          <Button
                variant={bill.voted ? "contained" : "outlined"}
                size="small"
                onClick={() => toggleVote(bill._id)}
                sx={{ mt: 1 }}
          >
                {bill.voted ? "Unvote" : "Upvote"}
          </Button>
          */}
          <Box mt={2} display="flex" alignItems="center" gap={1}>
            <Button
                size="small"
                variant={bill.voted ? "contained" : "outlined"}
                onClick={(e) => {
                    e.stopPropagation(); 
                    toggleVote(bill._id)}
                }
            >
                ▲ {bill.voted ? "Unvote" : "Upvote"}
            </Button>
            {/*<Typography variant="body2">{bill.upvoteCount} Visibility Upvotes | {bill.noPassCount} No Pass Votes | {bill.passCount} Pass Votes</Typography>*/}
            <Typography variant="body2">
                    {bill.upvoteCount} Visibility Upvotes |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openNoPassVoters(e, bill)}
                    >
                        {bill.noPassCount} No Pass Votes
                    </Box>{" "}
                    |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openPassVoters(e, bill)}
                    >
                        {bill.passCount} Pass Votes
                    </Box>
                </Typography>
          </Box>

          {/* Comment input */}
            {/*<TextField
                fullWidth
                size="small"
                placeholder="Add a comment"
                value={bill.newComment || ""}
                onChange={(e) =>
                    setBills(prev =>
                    prev.map((b, idx) =>
                        idx === i ? { ...b, newComment: e.target.value } : b
                    )
                    )
                }
            />
            <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                onClick={() => handleAddComment(bill._id, bill.newComment)}
            >
                Submit Comment
            </Button>*/}

            {/*
            <Button
                size="small"
                sx={{ mt: 1 }}
                onClick={() => history.push(`/bill/${bill._id}/comments`)}
            >
                View Comments
            </Button>
            */}
            {/*}
            <Button
                variant="outlined"
                size="small"
                onClick={() => history.push(`/bill/${bill._id}/comments`)}
                sx={{ mt: 1 }}
            >
                View Comments
            </Button>
            */}
        </Box>
      );
    })}
    <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={4}
        >
            {/* jump back 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpBackward}
                disabled={page <= 1}
            >
                {"<< 10"}
            </Button>

            <Pagination
                count={totalPages}
                page={page}
                onChange={(event, value) => setPage(value)}
                color="primary"
                size="large"
                siblingCount={1}
                boundaryCount={2}
                //showFirstButton
                //showLastButton
                hidePrevButton 
                hideNextButton
            />

            {/* jump forward 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpForward}
                disabled={page >= totalPages}
            >
                {"10 >>"}
            </Button>
        </Box>
    </Box>
    {/* --- Dialog --- */}
            {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
                <DialogTitle>Cast Your Power Vote</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} mb={2}>
                        <Button
                            variant={voteType === "Pass" ? "contained" : "outlined"}
                            onClick={() => setVoteType("Pass")}
                        >
                            Pass
                        </Button>
                        <Button
                            variant={voteType === "No Pass" ? "contained" : "outlined"}
                            onClick={() => setVoteType("No Pass")}
                        >
                            No Pass
                        </Button>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button 
                        variant="outlined" 
                        onClick={handleSubmitVote}
                        disabled={!comment || !voteType}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
            </Dialog>*/}
            <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} mb={2}>
                        <Button
                            variant={voteType === "NP" ? "contained" : "outlined"}
                            onClick={() => setVoteType("NP")}
                        >
                            No Pass
                        </Button>
                        <Button
                            variant={voteType === "P" ? "contained" : "outlined"}
                            onClick={() => setVoteType("P")}
                        >
                            Pass
                        </Button>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="outlined"
                        onClick={handleSubmitVote}
                        disabled={!comment || !voteType}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoBill);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoBill(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

    </div>
  );
}

export default Page2SubPageB2;

/*
import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageB2() {
  return (
    <Box p={4}>
      <Typography variant="h4">Bills</Typography>
    </Box>
  );
}

export default Page1SubPageB2;
*/